<template>
  <div class="ic-form__r-02">
    <FormWrapper :validator="$v.form">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-8">
          <p class="mbm" v-html="$t('form_r02a_introtext')"></p>
        </div>
      </div>
      <IcFormContactName v-model="form.name" />
      <IcFormContactEmail
        v-model="form.email"
        :withAgreement="true"
        @update:agreement="form.emailAgreement = $event"
        @update:pollAgreement="form.pollAgreement = $event"
      />
      <IcFormContactPhone v-model="form.phone" />
      <IcFormContactAddress v-model="form.address" />

      <IcFormContactConnection
        v-model="form.connection"
        :withDelay="true"
        :minDate="minDate"
        :endDate="endDate"
      />


      <IcFormContactBank v-model="form.bank" />
      <div>
        <IcCheckbox v-model="form.extra" :val="1" id="extra">{{$t('mam_dodatkowe_uwagi')}}</IcCheckbox>  
      </div>
      <div v-if="form.extra">
        <h3>Wiadomość</h3>
        <IcFormContactMessage v-model="form.message" />
        <IcFormContactFiles v-model="form.files" :maxFiles="5"/>
      </div>
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"  :is_visible="false" :value="true"
              :label="$t('label_agreement_checkbox')" content="form_agreement_r">
      </IcFormAgreements>

      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormComplaintR02 from "./r_02";
import validations from "./Validation/r_02.js";
import moment from "moment";

export default {
  name: "IcFormComplaintR02A",
  extends: IcFormComplaintR02,
  validations,
  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      form: {
        type: "r02a",
        extra: false,
        agreement: 1
      }
    };
  }
};
</script>

<style>
</style>
